import React, { useEffect, useState } from "react";
import {
  Table,
  Tag,
  Space,
  Drawer,
  Form,
  Descriptions,
  Col,
  Row,
  Button,
} from "antd";
import _ from "lodash";
import moment from "moment";
import { professionalService } from "../../../_services";
import { professionalAction } from "../../../_actions";
import { LanguageContext } from "../../../context/LanguageContext";
import { useContext } from "react";

const data = [];

export const NCRInfomationTable = (props) => {
  const [tblData, SetTblData] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [show, setShow] = useState(false);
  const [view, setView] = useState();
  const { t } = useContext(LanguageContext);

  const handleOpen = () => {
    setShow(!show);
  };
  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user"));
    professionalService.getDistrict(user.cityId).then((res) => {
      setDistricts(res.pc_districts);
    });
  }, []);

  console.log("districts", districts);
  const columns = [
    {
      title: t("sr.no"),
      dataIndex: "key",
      key: "key",
    },
    {
      title: "NCR number",
      dataIndex: "ncr_registernumber",
      key: "ncr_registernumber",
    },
    {
      title: "नोंदवलेले डेट",
      dataIndex: "occurrence_datetime",
      key: "occurrence_datetime",
      render: (text, record) => (
        <Space>
          <p>
            {moment(record.occurrence_datetime)
              .local()
              .format("YYYY-MM-DD hh:mm A")}
          </p>
        </Space>
      ),
    },
    {
      title: "घटनेचा प्रकार",
      dataIndex: "subHeading",
      key: "subHeading",
    },
    {
      title: "केलेली कारवाई",
      dataIndex: "actions_taken",
      key: "actions_taken",
    },
    {
      title: "ऑफिसर चे नाव",
      dataIndex: "officer_name",
      key: "officer_name",
    },
    {
      title: t("action"),
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div className="action-links-responsive">
          <Space size="middle">
            <a
              onClick={() => {
                handleOpen();
                setView(record);
              }}
            >
              {t("view1")}
            </a>
          </Space>
        </div>
      ),
    },
  ];

  useEffect(() => {
    let tempData = [];

    tempData =
      props.data &&
      props.data.map((res, index) => {
        return {
          ...res,
          key: index + 1,
          //preventive_action: getPreventiveName(res && res.preventive_action),
        };
      });
    SetTblData(tempData);
    // SetTblData
  }, [props.data]);

  return (
    <>
      <Table columns={columns} dataSource={tblData} />
      <Drawer
        title={t("professional_criminal_included")}
        width={900}
        maskClosable={false}
        closable={false}
        onClose={handleOpen}
        visible={show}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <div
              className="steps-action"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <Button onClick={handleOpen} style={{ marginRight: 8 }}>
                  {t("cancel")}
                </Button>
              </div>
            </div>
          </div>
        }
      >
        <div className="ncr-view-container">
          {/* Main Title */}
          <p className="section-title">NCR माहिती</p>

          <Row gutter={16}>
            {/* NCR Number */}
            <Col span={12}>
              <Descriptions>
                <Descriptions.Item
                  label={<span className="sub-heading_1">NCR number</span>}
                >
                  {view?.ncr_registernumber}
                </Descriptions.Item>
              </Descriptions>
            </Col>

            {/* Occurrence Date/Time */}
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Descriptions column={1}>
                <Descriptions.Item
                  label={
                    <span className="sub-heading_1">
                      घटना घडल्याची तारीख व वेळ
                    </span>
                  }
                >
                  {moment(view?.occurrence_datetime)
                    .local()
                    .format("YYYY-MM-DD hh:mm A")}
                </Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={12}>
              <Descriptions column={1}>
                <Descriptions.Item
                  label={
                    <span className="sub-heading_1">
                      माहिती नोंदवल्याची तारीख व वेळ
                    </span>
                  }
                >
                  {moment(view?.recorded_datetime)
                    .local()
                    .format("YYYY-MM-DD hh:mm A")}
                </Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
          <div className="after-desc">घटना प्रकार (NC)</div>
          <Row gutter={16} style={{ marginTop: "12px" }}>
            <Col span={12}>
              <Descriptions column={1}>
                <Descriptions.Item
                  label={<span className="sub-heading_1">शीर्षक</span>}
                >
                  {view?.headingName}
                </Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={12}>
              <Descriptions column={1}>
                <Descriptions.Item
                  label={<span className="sub-heading_1">घटनेचा प्रकार</span>}
                >
                  {view?.sub_heading_name &&
                    view?.sub_heading_name.length > 0 &&
                    view?.sub_heading_name.map((sub, index) => (
                      <>
                        {sub}
                        {","}
                      </>
                    ))}
                </Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>

          <p className="section-title">कायदा-कलम</p>

          <Row gutter={16} style={{ marginTop: "12px" }}>
            <Col span={12}>
              <Descriptions column={1} size="small">
                {(view?.kalamKayda || []).map((item, index) => (
                  <Descriptions.Item key={index}>
                    <div style={{ display: "flex", gap: "20px" }}>
                      <span>
                        <strong>कायदा:</strong> {item.rulesName || "-"}
                      </span>
                      <span>
                        <strong>कलम:</strong> {item.kalam || "-"}
                      </span>
                    </div>
                  </Descriptions.Item>
                ))}
              </Descriptions>
            </Col>
          </Row>

          {/* Officer Information Title */}
          <p className="section-title">अधिकारी माहिती</p>

          <Row gutter={16}>
            <Col span={12}>
              <Descriptions column={1}>
                <Descriptions.Item
                  label={
                    <span className="sub-heading_1">
                      अधिकारी / कर्मचारी चे नाव
                    </span>
                  }
                >
                  {view?.officer_name}
                </Descriptions.Item>
              </Descriptions>
            </Col>

            <Col span={12}>
              <Descriptions column={1}>
                <Descriptions.Item
                  label={<span className="sub-heading_1">फोन नंबर</span>}
                >
                  {view?.officer_mobile_no}
                </Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>

          {/* Action Taken Title */}
          <p className="section-title">केलेली कारवाई</p>

          <Row gutter={16}>
            {/* Actions Taken */}
            <Col span={12}>
              <Descriptions column={1}>
                <Descriptions.Item
                  label={<span className="sub-heading_1">केलेली कारवाई</span>}
                >
                  {view?.actions_taken}
                </Descriptions.Item>
              </Descriptions>
            </Col>

            {/* Police Station Action */}
            <Col span={12}>
              <Descriptions column={1}>
                <Descriptions.Item
                  label={
                    <span className="sub-heading_1">
                      {t("action_taken_police_station")}
                    </span>
                  }
                >
                  {view?.action_taken_police_station}
                </Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
        </div>
      </Drawer>
    </>
  );
};
